import { createRoute } from '@tanstack/react-router';
import { tourConfigRoute } from '@/features/dashboard/tourConfig/routes/tourConfigRoutes.ts';
import TourCustomFieldsConfigPage from '@/features/dashboard/tourCustomFields/pages/TourCustomFieldsConfigPage.tsx';

export const tourCustomFieldsRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'form',
  component: TourCustomFieldsConfigPage,
});
